<template>
    <a v-if="koreRegisterReady" :class="['register-link', variant]" @click="koreRegister()">{{content}}</a>
    <a v-else :class="['register-link', variant]" href="/#/register/select-type">{{content}}</a>
</template>

<script>
var AES = require("crypto-js/aes");
var CryptoJS = require("crypto-js");
import globalStore from "../variables";

export default {
    name: "RegisterLink",
    props: {
        content: {
            default: 'Register'
        },
        variant: {
            default: 'blue'
        }
    },
    data() {
        return {
            koreRegisterReady: false
        }
    },
    methods: {
        koreRegister() {
            //keyCloakUrl(right for development)/register?token=JWT_TOKEN_GOES_THERE
            let encryptedData = CryptoJS.AES.encrypt(JSON.stringify({source: 'simon'}), globalStore.data.keycloakRegisterKey);
            let redirectToken = window.btoa(encryptedData.toString());
            window.location.href = globalStore.data.keycloakRegisterUrl + '?token=' + redirectToken
            //console.log(globalStore.data.keycloakRegisterUrl + '?token=' + redirectToken)
        }
    }
}
</script>

<style lang="scss">
    .register-link {
        cursor: pointer;
        &.blue {
            color: #0088ff !important;
        }
        &.white {
            color: #fff;
        }
    }
</style>